<template>
  <div>
    <!-- <div class="background background-image"></div> -->
    <!-- <div class="background"></div> -->
    <fullscreen-img/>
    <span id="personal" class="section-anchor"/>
    <div id="personal" class="block personal-block">
      <div class="personal-picture" @mouseover="secondPic=true" @mouseleave="secondPic=false">
        <transition name="fade">
          <img v-if="!secondPic" class="person-pic" :src="require('@/assets/imgs/thumbnails/' + data.img1)"/>
        </transition>
        <transition name="fade">
          <img v-if="secondPic" class="person-pic" :src="require('@/assets/imgs/thumbnails/' + data.img2)"/>
        </transition>
      </div>
      <h1>{{ data.name }}</h1>
      <div>
        <!-- Email -->
        <email-link v-if="data.email" :email="data.email"></email-link>
        <!-- Github -->
        <a v-if="data.github" :href="data.github" target="_blank">
          <svg-icon name="github"/>
        </a>
        <!-- Gitlab -->
        <a v-if="data.gitlab" :href="data.gitlab" target="_blank">
          <svg-icon name="gitlab"/>
        </a>
        <!-- PubKey -->
        <a v-if="data.pubkey"
           :href="require(`@/assets/pubkeys/${data.pubkey}`)"
           :title="$t('gpg public key')"
           target="_blank">
          <svg-icon name="lock"/>
        </a>
      </div>
      <p v-for="paragraph of data.description">{{ paragraph }}</p>
    </div>

    <!-- Projects -->
    <span id="projects" class="section-anchor"/>
    <a class="category-title"
       href="#projects" v-smooth-scroll>
      <h2>
        <svg-icon name="clipboard" class="inv-color"/>
        {{ $t('projects') }}
      </h2>
    </a>
    <project-list :projects="data.projects"
                  :order="data['projects order']"
                  :partners="data.partners"/>
    
    <!-- Papers -->
    <span id="papers" class="section-anchor"/>
    <a class="category-title"
       href="#papers" v-smooth-scroll>
      <h2>
        <svg-icon name="book" class="inv-color"/>
        {{ $t('papers') }}
      </h2>
    </a>
    <ul>
      <li v-for="paper, i of data.papers" class="paper-item">
        <a :href="paper.url" target="_blank">
          {{ paper.title }} ({{ paper.date }}) <span v-if="paper.description">• {{ paper.description }}</span>
        </a>
      </li>
    </ul>

    <!-- Events -->
    <span id="events" class="section-anchor"/>
    <a class="category-title"
       href="#events" v-smooth-scroll>
      <h2>
        <svg-icon name="compass" class="inv-color"/>
        {{ $t('events') }}
      </h2>
    </a>
    <project-list :projects="data.events"
                  :order="data['events order']"
                  :partners="data.partners"/>

    <!-- Experiments -->
    <span id="experiments" class="section-anchor"/>
    <a class="category-title"
       href="#experiments" v-smooth-scroll>
      <h2>
        <svg-icon name="alert-triangle" class="inv-color"/>
        {{ $t('experiments') }}
      </h2>
    </a>
    <project-list :projects="data.experiments"
                  :order="data['experiments order']"
                  :partners="data.partners"/>
  </div>
</template>

<script>
import data from '@/dataLoader'
import {metaSetter} from '@/mixins'
import {getImgUrl} from '@/utils'
import ProjectList from '@/components/ProjectList'
import FullscreenImg from '@/components/FullscreenImg'

export default {
  mixins: [metaSetter],
  data () {
    return {
      // background: `background-image: url(${require('../assets/bfundo3.jpg')})`,
      secondPic: false
    }
  },
  components: {ProjectList, FullscreenImg},
  methods: {
    getImgUrl
  },
  computed: {
    data () { return data.andres[this.$i18n.locale] }
  },
  menuItems: [
    ['personal', 'user'],
    ['projects', 'clipboard'],
    ['papers', 'book'],
    ['events', 'compass'],
    ['experiments', 'alert-triangle']].map(([section, icon]) => {
      return {
        // to: {name: 'andres', hash: '#' + section},
        href: '#' + section,
        icon: icon,
        title: section
      }
    })
}
</script>



// WEBPACK FOOTER //
// src/components/PersonPage.vue